import { useEffect, useState } from "react";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import styled from "styled-components";

import { Placeholder } from "./Placeholder";
import Video from "../Video";

export type PreviewTab = "image" | "video";
interface Props {
  displayMediaTabs?: boolean;
  isLoading?: boolean;
  image_url: string;
  caption_file_url?: string;
  video_file_url?: string;
  video_thumbnail_file_url?: string;
  previewTab?: PreviewTab;
}

export const ImageAndVideoContainer: React.VFC<Props> = ({
  displayMediaTabs = true,
  isLoading = false,
  image_url,
  caption_file_url,
  video_file_url,
  video_thumbnail_file_url,
  previewTab,
}) => {
  const [selectedPreviewTab, setSelectedPreviewTab] = useState<PreviewTab>(
    previewTab || !video_file_url ? "image" : "video"
  );

  const hasBothMedia = image_url && video_file_url;

  useEffect(() => {
    if (previewTab) {
      setSelectedPreviewTab(previewTab);
    }
  }, [previewTab]);

  const getImage = (imageUrl?: string) => {
    if (!imageUrl) {
      return <Placeholder fontSize="120px" isLoading={isLoading} type="image" />;
    }
    return <img alt="exercise_image" src={imageUrl} />;
  };

  const getVideo = (videoFileUrl?: string, videoThumbnailFileUrl?: string) => {
    if (!videoFileUrl) {
      return <Placeholder fontSize="120px" isLoading={isLoading} type="video" />;
    }
    return <Video videoFileUrl={videoFileUrl} captionFileUrl={caption_file_url} poster={videoThumbnailFileUrl || ""} />;
  };

  return (
    <Container>
      {displayMediaTabs && hasBothMedia && (
        <Tabs
          value={selectedPreviewTab}
          onChange={(_event, newValue) => setSelectedPreviewTab(newValue)}
          style={{ marginBottom: "16px" }}
          centered
        >
          <Tab label="Image" value="image" />
          <Tab label="Video" value="video" />
        </Tabs>
      )}

      <ContentContainer>
        {selectedPreviewTab === "image" ? getImage(image_url) : getVideo(video_file_url, video_thumbnail_file_url)}
      </ContentContainer>
    </Container>
  );
};

const Container = styled.div``;

const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;

  & > img {
    height: auto;
    max-width: 100%;
  }
`;
